import { Controller } from "@hotwired/stimulus"

// Slider semanal + active-day toggle para el calendar nav del schedule.
// Click en dia inactivo -> selecciona ese dia (filtra la lista a ese dia).
// Click en dia activo -> deselecciona (limpia el filtro, vuelve al listado completo).
// Las dos transiciones se hacen client-side: actualizamos visual + URL via pushState
// + disparamos el fetch del list frame con frame.src = nueva_url.
export default class extends Controller {
  static targets = ["slides", "prevBtn", "nextBtn", "dayCircle", "dayDot"]
  static values = {
    index: { type: Number, default: 0 },
    total: Number
  }

  connect() {
    this.updatePosition()
  }

  prev() {
    if (this.indexValue > 0) {
      this.indexValue--
      this.updatePosition()
    }
  }

  next() {
    if (this.indexValue < this.totalValue - 1) {
      this.indexValue++
      this.updatePosition()
    }
  }

  setActive(event) {
    event.preventDefault()

    const link = event.currentTarget
    const targetDay = link.dataset.day
    const targetCircle = link.querySelector("[data-manage--schedule-nav-target='dayCircle']")
    const isCurrentlyActive = targetCircle?.dataset.active === "true"
    const newActiveDay = isCurrentlyActive ? null : targetDay

    const url = new URL(window.location.href)
    if (newActiveDay) {
      url.searchParams.set("day", newActiveDay)
    } else {
      url.searchParams.delete("day")
    }
    url.searchParams.delete("page")

    window.history.pushState({}, "", url.toString())

    const frame = document.getElementById(link.dataset.turboFrame)
    if (frame) frame.src = url.toString()

    this.dayCircleTargets.forEach(circle => {
      const shouldBeActive = newActiveDay !== null && circle.dataset.day === newActiveDay
      circle.dataset.active = shouldBeActive ? "true" : "false"
      if (shouldBeActive) {
        circle.style.backgroundColor = "#000"
        circle.style.color = "#fff"
      } else {
        circle.style.removeProperty("background-color")
        circle.style.removeProperty("color")
      }
    })

    this.dayDotTargets.forEach(dot => {
      const parent = dot.closest("[data-manage--schedule-nav-target='dayCircle']")
      if (!parent) return
      dot.style.display = (newActiveDay !== null && parent.dataset.day === newActiveDay) ? "none" : ""
    })
  }

  updatePosition() {
    const offset = -(this.indexValue * 100)
    this.slidesTarget.style.transform = `translateX(${offset}%)`

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.classList.toggle("opacity-20", this.indexValue === 0)
      this.prevBtnTarget.classList.toggle("cursor-default", this.indexValue === 0)
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.classList.toggle("opacity-20", this.indexValue >= this.totalValue - 1)
      this.nextBtnTarget.classList.toggle("cursor-default", this.indexValue >= this.totalValue - 1)
    }
  }
}
